// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"53d7d1dd","239":"0983eaf5","368":"063cd55a","415":"36550608","447":"c169d5e8","453":"54c2b86a","667":"6ea7ba2a","734":"5a39ccca","750":"abed6e9f","831":"e22051ff","980":"9120a645"}[chunkId] + ".chunk.js";
};